






































































































































import { Vue, Component } from "vue-property-decorator";
import SiteMessagesForm from "@/components/forms/SiteMessagesForm.vue";
import Axios from "axios";

@Component({
  components: {
    SiteMessagesForm,
  },
})
export default class SiteMessages extends Vue {
  // Local Component Properties
  private headers: Array<object> = [
    { text: "Website", value: "site" },
    { text: "Section", value: "section" },
    { text: "Description", value: "description" },
    { text: "Updated On", value: "updatedOn" },
    { text: "Edit", value: "actions", sortable: false },
  ];

  // Used for formatting the text and mapping the functions
  private textFormatting: Array<object> = [];

  // TODO: Items should be coming from a back-end
  private items: Array<object> = [];
  private dialog: boolean = false;
  private section: string = "";
  private description: string = "";

  // Event Handlers
  private editSiteMessage(siteMessage) {
    this.section = siteMessage.section;
    this.dialog = true;
  }

  // The event emits a new array we want to assign the new array from the event
  // The reasoning is because we will need to map each value in the array to a piece of functionality.
  private testOnChange(event) {
    this.textFormatting = event;
  }

  private saveSiteMessage() {
    // TODO: Steps to take to call the azure function.
    const axios = Axios.create({
      baseURL: "http://localhost:7071/api/",
    });

    const requestObject = {};

    axios.post("ctc-site-messages", requestObject);

    // TODO: If the site message is brand new meaning it is being added a post call should be used.
    // TODO: If the site messages are being edited meaning that they are assigned an Id then we would use a put call at this time.
  }

  private openSiteMessageForm() {
    this.dialog = true;
  }

  private closeSiteMessageForm() {
    this.clearText();
    this.dialog = false;
  }

  private clearText() {
    this.section = "";
  }

  // Methods
  // TODO: Remove this when the backend is implemented.
  private initialize() {
    this.items = [
      {
        site: "HIVE",
        section: "Welcome Message",
        description: "The welcome message to HIVE",
        updatedOn: "2020-11-16",
      },
    ];
  }

  // LifeCycle Hooks
  private created() {
    this.initialize();
    // TODO: When the items are in the back end we will want to call that API/Function in order to get the data here.
  }
}
